<nav aria-label="Payroll Management">
  <ul class="nav nav-tabs mb-3">
    <li class="nav-item" *ngFor="let tab of tabs">
      <a class="nav-link" [routerLink]="tab.route" routerLinkActive="active"
         [routerLinkActiveOptions]="{ exact: true }">{{ tab.label }}</a>
    </li>
  </ul>
</nav>
